import axios from "@/configs/axios";

export const getTeamsImportStatus = async (batch_id: string): Promise<any> => {
  const url = `${process.env.REACT_APP_SERVER_HOST}/teams-sync/import-status/${batch_id}`;
  const { data, status } = await axios.get<string>(url, {
    headers: {
      "Cache-Control": "no-store",
    },
  });
  return { data: data, httpStatus: status };
};
